(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-pz-contact-select]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const trigger = root.querySelector('[data-pz-contact-select-trigger]');
      const menu = root.querySelector('[data-pz-contact-select-menu]');
      const input = root.querySelector('[data-pz-contact-select-input]');
      const label = root.querySelector('[data-pz-contact-select-label]');
      const options = [...menu.querySelectorAll('[role="option"]')];

      const close = () => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-open');
      };

      const open = () => {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        root.classList.add('is-open');
        const selected = options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0];
        requestAnimationFrame(() => selected.focus({ preventScroll: true }));
      };

      trigger.addEventListener('click', () => menu.hidden ? open() : close());

      options.forEach((option) => {
        option.addEventListener('click', () => {
          options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
          input.value = option.dataset.value;
          label.textContent = option.textContent.trim();
          close();
          trigger.focus({ preventScroll: true });
        });
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          trigger.focus({ preventScroll: true });
        }
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) close();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();